/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Card, Avatar, useMediaQuery } from '@mui/material';
import {
  displayFlex,
  fontsize14,
  fontsize24,
  fontWeightBold,
  poppins400,
  poppins500,
} from 'theme/common.style';
import { Grid } from 'antd';
import Calen from 'assets/icons/Calen.svg';
import { shadowColor } from 'theme/color';
import { ReactComponent as BusinessReport } from 'assets/icons/status_live.svg';

import {
  statusCont,
  statusLiveHead,
  currentweek,
} from './CardHeaderContainer.style';
import { Stack } from '@mui/system';
import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import { useTheme } from '@emotion/react';

const TableCalendar = () => {
  return (
    <svg
      width="176"
      height="31"
      viewBox="0 0 176 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4913_15469)">
        <rect x="4" y="3" width="168" height="23" rx="4" fill="white" />
      </g>
      <path
        d="M156.869 19.6308C156.811 19.5743 156.563 19.3609 156.359 19.1622C155.076 17.9971 152.976 14.9576 152.335 13.3668C152.232 13.1252 152.014 12.5144 152 12.188C152 11.8753 152.072 11.5772 152.218 11.2927C152.422 10.9381 152.743 10.6537 153.122 10.4978C153.385 10.3975 154.172 10.2416 154.186 10.2416C155.047 10.0857 156.446 10 157.992 10C159.465 10 160.807 10.0857 161.681 10.2133C161.695 10.228 162.673 10.3838 163.008 10.5543C163.62 10.867 164 11.4778 164 12.1315V12.188C163.985 12.6137 163.605 13.509 163.591 13.509C162.949 15.0141 160.952 17.9834 159.625 19.1768C159.625 19.1768 159.284 19.5129 159.071 19.659C158.765 19.887 158.386 20 158.007 20C157.584 20 157.19 19.8724 156.869 19.6308"
        fill="#6D6868"
        fill-opacity="0.54"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 6.43245C16 6.27684 16 6.19903 15.9491 6.15423C15.8982 6.10944 15.8224 6.11915 15.6709 6.13857C14.5496 6.28229 13.7681 6.57508 13.1716 7.17157C12 8.34315 12 10.2288 12 14C12 17.7712 12 19.6569 13.1716 20.8284C14.3431 22 16.2288 22 20 22H22C25.7712 22 27.6569 22 28.8284 20.8284C30 19.6569 30 17.7712 30 14C30 10.2288 30 8.34315 28.8284 7.17157C28.2319 6.57508 27.4504 6.28229 26.3291 6.13857C26.1776 6.11915 26.1018 6.10944 26.0509 6.15424C26 6.19903 26 6.27684 26 6.43245L26 8.5C26 9.32843 25.3284 10 24.5 10C23.6716 10 23 9.32843 23 8.5L23 6.30005C23 6.15898 23 6.08844 22.9561 6.04451C22.9123 6.00059 22.8418 6.0005 22.7009 6.00031C22.4748 6 22.2412 6 22 6H20C19.7588 6 19.5252 6 19.2991 6.00031C19.1582 6.0005 19.0877 6.00059 19.0439 6.04452C19 6.08844 19 6.15898 19 6.30005L19 8.5C19 9.32843 18.3284 10 17.5 10C16.6716 10 16 9.32843 16 8.5L16 6.43245Z"
        fill="#6D6868"
        fill-opacity="0.54"
      />
      <path d="M17.5 4.5L17.5 8.5" stroke="white" stroke-linecap="round" />
      <path d="M24.5 4.5L24.5 8.5" stroke="white" stroke-linecap="round" />
      <circle cx="16.5" cy="12.5" r="0.5" fill="white" />
      <circle cx="19.5" cy="12.5" r="0.5" fill="white" />
      <circle cx="22.5" cy="12.5" r="0.5" fill="white" />
      <circle cx="25.5" cy="12.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="15.5" r="0.5" fill="white" />
      <circle cx="19.5" cy="15.5" r="0.5" fill="white" />
      <circle cx="22.5" cy="15.5" r="0.5" fill="white" />
      <circle cx="25.5" cy="15.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="18.5" r="0.5" fill="white" />
      <circle cx="19.5" cy="18.5" r="0.5" fill="white" />
      <circle cx="22.5" cy="18.5" r="0.5" fill="white" />
      <circle cx="25.5" cy="18.5" r="0.5" fill="white" />
      <path
        d="M47.072 10.636V11.524H44.792V19H43.7V11.524H41.408V10.636H47.072ZM51.2842 19.108C50.6682 19.108 50.1082 18.968 49.6042 18.688C49.1082 18.408 48.7162 18.012 48.4282 17.5C48.1482 16.98 48.0082 16.38 48.0082 15.7C48.0082 15.028 48.1522 14.436 48.4402 13.924C48.7362 13.404 49.1362 13.008 49.6402 12.736C50.1442 12.456 50.7082 12.316 51.3322 12.316C51.9562 12.316 52.5202 12.456 53.0242 12.736C53.5282 13.008 53.9242 13.4 54.2122 13.912C54.5082 14.424 54.6562 15.02 54.6562 15.7C54.6562 16.38 54.5042 16.98 54.2002 17.5C53.9042 18.012 53.5002 18.408 52.9882 18.688C52.4762 18.968 51.9082 19.108 51.2842 19.108ZM51.2842 18.148C51.6762 18.148 52.0442 18.056 52.3882 17.872C52.7322 17.688 53.0082 17.412 53.2162 17.044C53.4322 16.676 53.5402 16.228 53.5402 15.7C53.5402 15.172 53.4362 14.724 53.2282 14.356C53.0202 13.988 52.7482 13.716 52.4122 13.54C52.0762 13.356 51.7122 13.264 51.3202 13.264C50.9202 13.264 50.5522 13.356 50.2162 13.54C49.8882 13.716 49.6242 13.988 49.4242 14.356C49.2242 14.724 49.1242 15.172 49.1242 15.7C49.1242 16.236 49.2202 16.688 49.4122 17.056C49.6122 17.424 49.8762 17.7 50.2042 17.884C50.5322 18.06 50.8922 18.148 51.2842 18.148ZM57.424 13.324V17.2C57.424 17.52 57.492 17.748 57.628 17.884C57.764 18.012 58 18.076 58.336 18.076H59.14V19H58.156C57.548 19 57.092 18.86 56.788 18.58C56.484 18.3 56.332 17.84 56.332 17.2V13.324H55.48V12.424H56.332V10.768H57.424V12.424H59.14V13.324H57.424ZM60.0551 15.688C60.0551 15.016 60.1911 14.428 60.4631 13.924C60.7351 13.412 61.1071 13.016 61.5791 12.736C62.0591 12.456 62.5911 12.316 63.1751 12.316C63.7511 12.316 64.2511 12.44 64.6751 12.688C65.0991 12.936 65.4151 13.248 65.6231 13.624V12.424H66.7271V19H65.6231V17.776C65.4071 18.16 65.0831 18.48 64.6511 18.736C64.2271 18.984 63.7311 19.108 63.1631 19.108C62.5791 19.108 62.0511 18.964 61.5791 18.676C61.1071 18.388 60.7351 17.984 60.4631 17.464C60.1911 16.944 60.0551 16.352 60.0551 15.688ZM65.6231 15.7C65.6231 15.204 65.5231 14.772 65.3231 14.404C65.1231 14.036 64.8511 13.756 64.5071 13.564C64.1711 13.364 63.7991 13.264 63.3911 13.264C62.9831 13.264 62.6111 13.36 62.2751 13.552C61.9391 13.744 61.6711 14.024 61.4711 14.392C61.2711 14.76 61.1711 15.192 61.1711 15.688C61.1711 16.192 61.2711 16.632 61.4711 17.008C61.6711 17.376 61.9391 17.66 62.2751 17.86C62.6111 18.052 62.9831 18.148 63.3911 18.148C63.7991 18.148 64.1711 18.052 64.5071 17.86C64.8511 17.66 65.1231 17.376 65.3231 17.008C65.5231 16.632 65.6231 16.196 65.6231 15.7ZM69.6644 10.12V19H68.5724V10.12H69.6644Z"
        fill="#6D6868"
      />
      <defs>
        <filter
          id="filter0_d_4913_15469"
          x="0"
          y="0"
          width="176"
          height="31"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4913_15469"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4913_15469"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
const Calendar = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 4.94221C7 4.7866 7 4.7088 6.9491 4.664C6.89819 4.6192 6.82244 4.62891 6.67094 4.64833C5.54965 4.79205 4.76806 5.08485 4.17157 5.68134C3 6.85291 3 8.73853 3 12.5098C3 16.281 3 18.1666 4.17157 19.3382C5.34315 20.5098 7.22876 20.5098 11 20.5098H13C16.7712 20.5098 18.6569 20.5098 19.8284 19.3382C21 18.1666 21 16.281 21 12.5098C21 8.73853 21 6.85291 19.8284 5.68134C19.2319 5.08485 18.4504 4.79205 17.3291 4.64833C17.1776 4.62891 17.1018 4.6192 17.0509 4.664C17 4.7088 17 4.7866 17 4.94222L17 7.00976C17 7.83819 16.3284 8.50976 15.5 8.50977C14.6716 8.50977 14 7.83819 14 7.00977L14 4.80982C14 4.66874 14 4.5982 13.9561 4.55428C13.9123 4.51036 13.8418 4.51026 13.7009 4.51007C13.4748 4.50977 13.2412 4.50977 13 4.50977H11C10.7588 4.50977 10.5252 4.50977 10.2991 4.51007C10.1582 4.51026 10.0877 4.51036 10.0439 4.55428C10 4.5982 10 4.66874 10 4.80982L10 7.00976C10 7.83819 9.32843 8.50976 8.50001 8.50977C7.67158 8.50977 7 7.83819 7 7.00977L7 4.94221Z"
        fill="#666666"
      />
      <path
        d="M8.5 3.00977L8.5 7.00977"
        stroke="white"
        stroke-linecap="round"
      />
      <path
        d="M15.5 3.00977L15.5 7.00977"
        stroke="white"
        stroke-linecap="round"
      />
      <circle cx="7.5" cy="11.0098" r="0.5" fill="white" />
      <circle cx="10.5" cy="11.0098" r="0.5" fill="white" />
      <circle cx="13.5" cy="11.0098" r="0.5" fill="white" />
      <circle cx="16.5" cy="11.0098" r="0.5" fill="white" />
      <circle cx="7.5" cy="14.0098" r="0.5" fill="white" />
      <circle cx="10.5" cy="14.0098" r="0.5" fill="white" />
      <circle cx="13.5" cy="14.0098" r="0.5" fill="white" />
      <circle cx="16.5" cy="14.0098" r="0.5" fill="white" />
      <circle cx="7.5" cy="17.0098" r="0.5" fill="white" />
      <circle cx="10.5" cy="17.0098" r="0.5" fill="white" />
      <circle cx="13.5" cy="17.0098" r="0.5" fill="white" />
      <circle cx="16.5" cy="17.0098" r="0.5" fill="white" />
    </svg>
  );
};

const ArrowDown = () => {
  const [ShowOfferCard, setShowOfferCard] = useState(false);
  return (
    <Typography
      onClick={() => setShowOfferCard(!ShowOfferCard)}
      sx={{
        border: '1px solid #F0F0F0',
        // padding: "5px 10px",
        height: '100%',
        width: '30px',
        marginLeft: '7px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {ShowOfferCard ? (
        <ExpandMoreOutlined sx={{ color: '#0065FC' }} />
      ) : (
        <ExpandLessOutlined sx={{ color: '#0065FC' }} />
      )}
    </Typography>
  );
};

function CardHeaderContainer(props) {
  const {
    title,
    icon,
    subTitle,
    tableCalendar = false,
    arrowDown = false,
  } = props;

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));

  return (
    <Typography
      component="div"
      sx={{
        ...statusCont,
        whiteSpace: 'nowrap',
        paddingBottom: matchessm ? '0px' : '10px',
      }}
    >
      {!matchessm && <img src={icon} alt="Live" />}
      <Typography
        component="div"
        sx={{
          ...statusLiveHead,
          ...poppins500,
          fontSize: matchessm ? '20px' : '24px',
          color: '#000000',
          paddingLeft: matchessm ? '0px' : '15px',
        }}
      >
        {title}
      </Typography>
      <Typography
        component="div"
        sx={[statusLiveHead, { fontSize: matches700 ? '14px' : '24px' }]}
      >
        {subTitle || ''}
      </Typography>
      {/* <Grid sx={displayFlex}> */}
      <Stack style={{ marginLeft: '30%' }}>
        {tableCalendar && <TableCalendar />}

        {/* </Stack>
        <Stack> */}
        {/* {arrowDown  && <ArrowDown/>} */}
      </Stack>
      {/* </Grid> */}
    </Typography>
  );
}

CardHeaderContainer.defaultProps = {
  subTitle: PropTypes.string,
};

CardHeaderContainer.propTypes = {
  icon: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
};

export default CardHeaderContainer;
